
/* @ngInject */
function PlanController ($scope, $rootScope, $timeout, AdminService, BillingService, ToastService) {
  $scope.pricingPackages = []
  $scope.pricingPlans = []
  $scope.deskfyAddons = []
  $scope.flags = {
    loading: false
  }

  $scope.selectedAddons = {}
  $scope.selectedPricingPackageId = null
  $scope.selectedPricingPlanId = null
  $scope.currentCompanyPlan = {
    package: null,
    plan: null,
    addons: []
  }

  const api = {
    _getPricingPackages,
    _handleGetPricingPackagesSuccess,
    _getPricingPlans,
    _handleGetPricingPlans,
    _getDeskfyAddons,
    _handleGetDeskfyAddons,
    _getCompanyPlan
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getCompanyPlan().then(() => { api._getPricingPackages() })
  }

  async function _getCompanyPlan () {
    const companyPlan = await $rootScope.getCompanyFeaturesAndAddons(true)
    const mappedAddons = Object.keys(companyPlan.addons).map(key => {
      return companyPlan.addons[key]
    })

    $scope.currentCompanyPlan = {
      packageId: companyPlan.pricingPackageId,
      plan: companyPlan.id,
      addons: mappedAddons
    }
  }

  async function _getPricingPackages () {
    BillingService.getPricingPackages().then(api._handleGetPricingPackagesSuccess)
  }

  function _handleGetPricingPackagesSuccess (response) {
    const { rows: pricingPackages } = response
    $scope.pricingPackages = pricingPackages.map(pricingPackage => ({ label: pricingPackage.name, value: pricingPackage.id, active: pricingPackage.id === $scope.currentCompanyPlan.packageId }))

    api._getPricingPlans($scope.currentCompanyPlan.packageId).then(() => { api._getDeskfyAddons($scope.currentCompanyPlan.plan) })
  }

  async function _getPricingPlans (pricingPackageId) {
    BillingService.getPlansByPricingPackage(pricingPackageId).then(api._handleGetPricingPlans)
  }

  function _handleGetPricingPlans (response) {
    const { rows: pricingPlans } = response
    $scope.pricingPlans = pricingPlans.map(pricingPlan => ({ label: pricingPlan.name, value: pricingPlan.id, active: pricingPlan.id === $scope.currentCompanyPlan.plan }))
  }

  $scope.onChangeSelectPricingPackage = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.selectedPricingPackageId = newValue
      api._getPricingPlans($scope.selectedPricingPackageId)
    }
    event.stopImmediatePropagation()
  }

  $scope.onChangeSelectPricingPlan = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.selectedPricingPlanId = newValue
      api._getDeskfyAddons($scope.selectedPricingPlanId)
    }
    event.stopImmediatePropagation()
  }

  async function _getDeskfyAddons (planId) {
    BillingService.getPlanAddons(planId).then(api._handleGetDeskfyAddons)
  }

  function _handleGetDeskfyAddons (response) {
    const { rows: addon } = response
    const currentCompanyAddonsIds = $scope.currentCompanyPlan.addons.map(addon => {
      $scope.selectedAddons[addon.id] = true

      return addon.id
    })

    $scope.deskfyAddons = addon.map(addon => ({ label: addon.title, name: addon.id, checked: currentCompanyAddonsIds.includes(addon.id) }))
  }

  $scope.addonChange = (event) => {
    const checkboxName = event.detail.name
    const checkboxValue = event.detail.value

    if (!checkboxValue) {
      delete $scope.selectedAddons[checkboxName]
    } else {
      $scope.selectedAddons[checkboxName] = true
    }

    event.stopImmediatePropagation()
  }

  $scope.handleSavePlan = async () => {
    $scope.selectedPricingPlanId = $scope.selectedPricingPlanId || $scope.currentCompanyPlan.plan
    $scope.flags.loading = true
    const selectedAddonsIds = Object.keys($scope.selectedAddons).map(Number)

    try {
      const companyWithBillingPackage = await $rootScope.getCompanyWithBillingPackage()
      await AdminService.updateCompanyBillingPackage(companyWithBillingPackage.id, $scope.selectedPricingPlanId, {
        maxLicenses: companyWithBillingPackage.billingPackage.maxLicenses,
        maxStorageGb: companyWithBillingPackage.billingPackage.maxStorageGb,
        addonsIds: selectedAddonsIds
      })

      $timeout(() => {
        $scope.flags.loading = false
        ToastService.showSuccessToast('Plano atualizado com sucesso!')
        $rootScope.getCompanyFeaturesAndAddons(true)
      })
    } catch (err) {
      console.error(err)
      ToastService.showErrorToast('Erro ao atualizar o plano')
    }
  }

  $scope.resetPlan = () => {
    activate()
  }
}

export { PlanController }
